"use client";
import React, { useState } from "react";
import Image from "next/image";

const ProductImageFullscreen = ({
    imageUrl,
    className,
    priority,
    setSelectedImage,
    imageAlt,
}: {
    imageUrl: string;
    className?: string;
    priority?: boolean;
    setSelectedImage?: (image: string | null) => void;
    imageAlt?: string;
}) => {
    const openModal = (imgUrl: string) => {
        if (setSelectedImage) {
            setSelectedImage(imgUrl);
        }
    };
    const image = imageUrl.substring(0, imageUrl.lastIndexOf("."));
    return (
        <>
            <picture>
                <source srcSet={`${image}_resize.avif`} type="image/avif" media="(max-width: 1023px)" />
                <source srcSet={`${image}_resize.webp`} type="image/webp" media="(max-width: 1023px)" />
                <source srcSet={`${image}.avif`} type="image/avif" />
                <source srcSet={`${image}.webp`} type="image/avif" />

                <img
                    src={imageUrl}
                    width={480}
                    height={480}
                    alt={imageAlt}
                    className={className}
                    loading={priority ? "eager" : "lazy"}
                    onClick={() => openModal(image)}
                />
            </picture>
        </>
    );
};

export default ProductImageFullscreen;
